import styled from "styled-components";
import { COLORS } from "../../../constants/variables";

export const PasarCarouselWrapper = styled("section")`
  //height: 500px;
  //background: #fff;
  //display: flex;
  //align-items: center;
  overflow: hidden;
  padding: 40px 0;
  @media screen and (max-width: 900px) {
    padding: 40px 0 0;
  }
  .title {
    font-size: 1.75rem;
    color: ${(props) => (props.subColor
    ? props.subColor
    : props.mainColor
      ? props.mainColor
      : "#fff")};
    margin-top: 0;
    margin-bottom: 26px;
    text-align: left;
    font-weight: 400;
    @media screen and (max-width: 900px) {
      margin-bottom: 80px;
    }
  }
  .wrapper {
    //height: 100%;
  }

  .flickity {
    //transform: translateX(-430px);
    width: 1120px;
    margin: auto;
    @media screen and (max-width: 900px) {
      transform: translateX(0);
      width: 90%;
    }
    @media screen and (min-width: 900px) and (max-width: 1120px) {
      width: 900px;
    }
    .flickity-viewport {
      overflow: visible;
    }
    .flickity-button {
      &.flickity-prev-next-button {
        background: transparent;
        z-index: 10;
        &.previous {
          right: calc(
            50% + ${(props) => (props.pageLength ? props.pageLength * 26 : 900)}px -
              530px
          );
          left: initial;
          top: -44px;
          @media screen and (max-width: 900px) {
            left: 0;
            right: initial;
          }
          @media screen and (min-width: 900px) and (max-width: 1120px) {
            right: calc(
              50% +
                ${(props) => (props.pageLength ? props.pageLength * 26 : 900)}px -
                400px
            );
          }
        }
        &.next {
          right: calc(
            50% + ${(props) => (props.pageLength ? props.pageLength * 26 : 900)}px -
              560px
          );
          top: -44px;
          @media screen and (max-width: 900px) {
            left: 30px;
            right: initial;
          }
          @media screen and (min-width: 900px) and (max-width: 1120px) {
            right: calc(
              50% +
                ${(props) => (props.pageLength ? props.pageLength * 26 : 900)}px -
                430px
            );
          }
        }
      }
      svg {
        path {
          fill: ${(props) => (props.mainColor ? props.mainColor : "#fff")};
        }
      }
    }
    .flickity-page-dots {
      top: -55px;
      right: 0;
      height: 20px;
      display: inline-flex;
      align-items: center;
      //width: 50%;
      justify-content: flex-end;
      @media screen and (max-width: 900px) {
        right: initial;
        left: 80px;
        justify-content: flex-start;
      }
      .dot {
        background-color: transparent;
        border: 1px solid ${(props) => (props.subColor ? "#000" : "#FFF")};
        border-radius: 100%;
        opacity: 1;

        &.is-selected{
          background-color: ${(props) => (props.subColor ? "#000" : "#FFF")};
        }
      }
    }
  }

  .banner-wrapper {
    height: 310px;
    @media screen and (max-width: 900px) {
      width: 90%;
      margin: 0 auto 20px;
    }
    .banner-item {
      background-color: #fff;
      width: 255px;
      height: 310px;
      margin: 0 12px;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 3px 16px rgba(0, 0, 0, 0.1);
      transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
      transform-origin: bottom;
      text-decoration: none;
      &:first-child {
        margin: 0 12px 0 0;
      }
      .banner-image {
        height: 150px;
        background-color: #ccc;
        background-position: center;
        background-size: cover;
      }

      .banner-title {
        padding: 20px;
        text-align: left;
        height: calc(100% - 150px);
        .sub-title {
          margin: 0;
          font-size: 1rem;
          color: #05a0d3;
          text-transform: uppercase;
        }

        .title {
          margin: 0 0 8px;
          color: ${COLORS.primaryRed};
          font-size: 1rem;
          text-transform: uppercase;
          font-weight: bold;
        }

        .content {
          margin: 0;
          color: ${COLORS.primaryBlack}; 
          font-size: 0.875rem;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          p {
            margin: 0;
          }
        }
      }
    }
  }
`;
